import { useLocation } from "@solidjs/router"
import { createMemo } from "solid-js"
import { type Tab, Tabs } from "@/designSystem/components/tabs"
import { useI18nContext } from "@/i18n/i18n-solid"
import { createBlogRouter } from "@/routes/posts-router"

const SUB_PAGES = ["/settings", "/forms", "/audience", "/stats"] as const

export function PublicationTabs() {
  const { paths } = createBlogRouter()
  const { LL } = useI18nContext()
  const location = useLocation()

  const tabs = createMemo((): Tab[] => [
    {
      label: LL().common.blog(),
      href: paths().url,
      iconName: "book-open-text",
    },
    {
      label: LL().blog.forms(),
      href: paths().forms(),
      iconName: "gift",
    },
    {
      label: LL().blog.audience(),
      href: paths().audience(),
      iconName: "users-round",
    },
    {
      label: LL().blog.stats(),
      href: paths().stats(),
      iconName: "bar-chart-big",
    },
    {
      label: LL().settings.title(),
      href: paths().settings(),
      iconName: "settings",
    },
  ])

  const activeHref = createMemo(() => {
    const pathname = location.pathname
    const matchedSubPage = SUB_PAGES.find(sub => pathname.includes(sub))

    if (!matchedSubPage) {
      return paths().url
    }

    switch (matchedSubPage) {
      case "/settings":
        return paths().settings()
      case "/forms":
        return paths().forms()
      case "/audience":
        return paths().audience()
      case "/stats":
        return paths().stats()
    }
  })

  return <Tabs tabs={tabs()} hue="amber" activeHref={activeHref()} />
}
